import { render, staticRenderFns } from "./mgrDiveStoreStudent.vue?vue&type=template&id=59487be5&scoped=true&"
import script from "./mgrDiveStoreStudent.vue?vue&type=script&lang=js&"
export * from "./mgrDiveStoreStudent.vue?vue&type=script&lang=js&"
import style0 from "./mgrDiveStoreStudent.vue?vue&type=style&index=0&id=59487be5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59487be5",
  null
  
)

export default component.exports